import { render, staticRenderFns } from "./add-process-modal.vue?vue&type=template&id=2162c1f2"
import script from "./add-process-modal.vue?vue&type=script&lang=js"
export * from "./add-process-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports